"use strict";

module.exports = {
  siteTitle: 'Groupe Philippe Marraud',
  sidebarLogo: 'sitelogo.png',
  fixedHeader: true
};